import {
  HomePageQuickDemo,
  landingPageVideo
} from "../../constant";
import { Box, Card, Grid, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import { motion } from "framer-motion"; // Import Framer Motion
import { useEffect, useState } from "react";
import MediaViewModel from "../MediaViewModel";

const splitTextIntoThreeParts = (text = "") => {
  if (!text.trim()) {
    return {
      part1: "",
      part2: "",
      part3: "",
    };
  }

  const words = text.trim().split(/\s+/);
  const totalWords = words.length;

  const partSize = Math.ceil(totalWords / 3);

  const part1 = words.slice(0, partSize).join(" ");
  const part2 = words
    .slice(partSize, partSize * 2)
    .join(" ");
  const part3 = words
    .slice(partSize * 2)
    .join(" ");

  return {
    part1,
    part2,
    part3,
  };
};



export default function HomeLanding() {
  const theme = useTheme();
  const [data, setdata] = useState(null);
  const [openModel, setOpenModel] = useState(false);

  useEffect(() => {
    getAddList();
  }, []);

  const getAddList = async () => {
    try {
      const url =
        "https://dev.ienergydigital.com/task-api/api/cms/entries/?type=landing_hero";

      const response = await axios.get(url);

      const entry =
        response?.data?.data?.entries?.[0] || {};

      const formatData = {
        id: entry?.id || null,
        heading1: entry?.contentJson?.heading1,
        textPart1: entry?.contentJson?.heading2,
        description:
          entry?.contentJson?.description || "",
        image:
          entry?.contentJson?.image || "",
        videoUrl: entry?.contentJson?.video,
        name: entry?.contentJson?.name,
      };

      setdata(formatData);
    } catch (error) {
      console.error(
        "Error fetching landing hero:",
        error
      );
    }
  };


  const textVariants2 = {
    hidden: { opacity: 0, x: "-100%" }, // Fully off-screen to the left
    visible: {
      opacity: 1,
      x: 0, // Moves to normal position
      transition: {
        duration: 0.9, // Slightly longer for a smooth feel
        ease: "easeOut", // Ensures smooth deceleration
        type: "tween",
      },
    },
  };


  const textVariants1 = {
    hidden: { opacity: 0, y: "-500%", scale: 0.8 }, // Starts above and smaller
    visible: {
      opacity: 1,
      y: 0, // Moves down into position
      scale: 1, // Expands to normal size
      transition: {
        duration: 1.5, // Smooth timing
        ease: "easeOut", // Decelerates smoothly
      },
    },
  };

  const isVideoFile = (url) => {
    if (!url) return false;

    return /\.(mp4|webm|ogg|mov)$/i.test(url);
  };


  const imageVariants = {
    hidden: { opacity: 0, x: 600, rotate: 20 }, // Starts from right and rotated
    visible: {
      opacity: 1,
      x: 0,
      rotate: 0,
      transition: {
        duration: 1.3,
        ease: "easeIn",
      },
    },
  };

  return (
    <Box sx={{ position: "relative", minHeight: { xs: "70vh", md: "70vh" }, overflow: "hidden", padding: { xs: "60px 24px", md: "60px 80px", lg: "60px 120px" }, margin: "auto", maxWidth: "100%" }}>
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: -1,
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src="/HomeBGVideo.webm" type="video/webm" />
        </video>
      </Box>

      {/* Content Overlay */}

      <Grid container spacing={{ xs: 4, sm: 6, md: 12 }}>
        {/* Left Side Text */}
        <Grid item xs={12} md={7} sx={{ display: "flex", flexDirection: "column", width: "80%" }}>
          {/* Title 1 */}
          <motion.div initial="hidden" animate="visible" variants={textVariants1} transition={{ delay: 0.4 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, fontSize: { xs: "2rem", sm: "2.5rem", md: "5rem" }, color: "white" }}
            >
              {data?.heading1}
            </Typography>
          </motion.div>

          {/* Title 2 */}
          <motion.div initial="hidden" animate="visible" variants={textVariants1} >
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, fontSize: { xs: "2rem", sm: "2.5rem", md: "5rem", color: "#61D1FA", }, color: "white" }}
            >
              {data?.textPart1}
            </Typography>
          </motion.div>

          {/* Description */}
          <motion.div initial="hidden" animate="visible" variants={textVariants2} transition={{ delay: 0.4 }}>
            <Box mt={4}>
              <Typography sx={{ fontSize: { xs: "16px", sm: "18px" }, fontWeight: 400, color: "#8C8CC2" }}>
                {data?.description}
              </Typography>
            </Box>
          </motion.div>

          {/* Button */}
          <motion.div initial="hidden" animate="visible" variants={textVariants2} transition={{ delay: 0.6 }}>
            <Box mt={6}>
              <IconButton
                sx={{
                  color: "#0fb4f0",

                }}
                onClick={() => setOpenModel(true)}
              >

                {data?.name}

                <Box
                  component="img"
                  src={HomePageQuickDemo}
                  alt="Quick Demo"
                  sx={{
                    ml: 0.5,
                  }}
                />
              </IconButton>
            </Box>
          </motion.div>
        </Grid>

        {/* Right Side Image */}
        <Grid item xs={12} md={5}>
          <motion.div
            initial="hidden"
            animate="visible"
            variants={imageVariants}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: { xs: "400px", sm: "500px", md: "500px" },
                margin: "0 auto",
                maxWidth: { xs: "100%", md: "none" },
                display: "flex",
                justifyContent: "center",
                overflow: "hidden",
                borderRadius: "12px",
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  width: "100%",
                  zIndex: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",

                  /* Smooth fade from ALL sides */
                  WebkitMaskImage: `
      linear-gradient(to right,
        transparent 0%,
        rgba(0,0,0,0.3) 8%,
        rgba(0,0,0,0.8) 15%,
        rgba(0,0,0,1) 25%,
        rgba(0,0,0,1) 75%,
        rgba(0,0,0,0.8) 85%,
        rgba(0,0,0,0.3) 92%,
        transparent 100%
      ),
      linear-gradient(to bottom,
        transparent 0%,
        rgba(0,0,0,0.3) 8%,
        rgba(0,0,0,0.8) 15%,
        rgba(0,0,0,1) 25%,
        rgba(0,0,0,1) 75%,
        rgba(0,0,0,0.8) 85%,
        rgba(0,0,0,0.3) 92%,
        transparent 100%
      )
    `,
                  WebkitMaskComposite: "source-in",

                  maskImage: `
      linear-gradient(to right,
        transparent 0%,
        rgba(0,0,0,0.3) 8%,
        rgba(0,0,0,0.8) 15%,
        rgba(0,0,0,1) 25%,
        rgba(0,0,0,1) 75%,
        rgba(0,0,0,0.8) 85%,
        rgba(0,0,0,0.3) 92%,
        transparent 100%
      ),
      linear-gradient(to bottom,
        transparent 0%,
        rgba(0,0,0,0.3) 8%,
        rgba(0,0,0,0.8) 15%,
        rgba(0,0,0,1) 25%,
        rgba(0,0,0,1) 75%,
        rgba(0,0,0,0.8) 85%,
        rgba(0,0,0,0.3) 92%,
        transparent 100%
      )
    `,
                  maskComposite: "intersect",
                }}
              >
                {isVideoFile(data?.image) ? (
                  <Box
                    component="video"
                    src={data?.image}
                    autoPlay
                    muted
                    loop
                    playsInline
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      display: "block",
                      filter: `
    drop-shadow(0 20px 60px rgba(0,0,0,0.2))
    brightness(1.05)
    contrast(1.03)
  `,
                      transform: "scale(1.03)",
                    }}
                  />
                ) : (
                  <Box
                    component="img"
                    src={data?.image}
                    alt="Hero"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                )}
              </Box>
            </Box>
          </motion.div>
        </Grid>
      </Grid>
      <MediaViewModel
        open={openModel}
        onClose={() => setOpenModel(false)}
        videoUrl={data?.videoUrl}
      />
    </Box>

  );
}